<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
  >
  <button
    nz-button
    nzType="primary"
    [disabled]="setOfCheckedId.size === 0"
    (click)="createOrderFromSelection()"
  >
    <i nz-icon nzType="plus-circle" nzTheme="outline"></i><span>Bestellung erstellen</span>
  </button>
  <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
  <div class="table-filter-field">
    <label for="supplierFilter">Lieferant</label>
    <nz-select
      class="table-filter-field__control"
      nzPlaceHolder="Lieferant wählen"
      nzShowSearch
      nzServerSearch
      (nzOnSearch)="onSearchSupplier($event)"
      [compareWith]="compareSimpleList"
      nzMode="multiple"
      [(ngModel)]="selectedSuppliers"
      (ngModelChange)="onRefreshList()"
      id="supplierFilter"
    >
      @for (o of suppliersList; track o) {
        @if (!isSuppliersLoading) {
          <nz-option [nzValue]="o" [nzLabel]="o.value"></nz-option>
        }
      }
      @if (isSuppliersLoading) {
        <nz-option nzDisabled nzCustomContent>
          <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
        </nz-option>
      }
    </nz-select>
  </div>
  <label
    class="table-filter-check"
    nz-checkbox
    [(ngModel)]="showArticlesBelowMinStock"
    (ngModelChange)="onRefreshList()"
  >Produkte, die unter dem Mindestbestand liegen</label>
</app-table-header>
<div class="grouped-table-hscroll">
<nz-table appColumnLayout
  #tableRef
  nzShowSizeChanger
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="non-packing-list-table"
  >
  <thead>
    <tr>
      <th data-col-key="selection"
        rowspan="2"
        nzWidth="60px"
        [(nzChecked)]="checked"
        [nzIndeterminate]="indeterminate"
        (nzCheckedChange)="onAllChecked($event)"
      ></th>
      <th nzColumnKey="group-article" colspan="6" class="group-head">Artikel</th>
      <th nzColumnKey="group-next-delivery" colspan="3" class="group-head next-deliver">Nächste Lieferung</th>
      <th nzColumnKey="actions" rowspan="2" nzWidth="73px"></th>
    </tr>
    <tr>
      <th nzColumnKey="articleVariant.id" [nzSortFn]="true" nzWidth="75px" nzSortOrder="descend">#ID</th>
      <th nzColumnKey="articleVariant.orderNumber" [nzSortFn]="true" nzWidth="120px">Nummer</th>
      <th nzColumnKey="articleVariant.name" [nzSortFn]="true" nzWidth="240px">Name</th>
      <th nzColumnKey="nonPackableState" [nzSortFn]="true" nzWidth="110px">Bestand</th>
      <th nzColumnKey="minStock" [nzSortFn]="true" nzWidth="140px">Mindestbestand</th>
      <th nzColumnKey="supplier.name" [nzSortFn]="true" nzWidth="200px">Letzter Lieferant</th>
      <th class="next-deliver" nzColumnKey="orderDate" [nzSortFn]="true" nzWidth="140px">Bestelltermin</th>
      <th nzColumnKey="orderSupplier.name" [nzSortFn]="true" nzWidth="220px">Lieferant der Bestellung</th>
      <th nzColumnKey="orderQuantitySum" [nzSortFn]="true" nzWidth="180px">Menge</th>
    </tr>
  </thead>
  <tbody>
    @for (article of data.results; track article.articleVariant.id) {
      <tr>
        <td
          [nzChecked]="setOfCheckedId.has(article.articleVariant.id)"
          (nzCheckedChange)="onItemChecked(article.articleVariant.id, $event)"
        ></td>
        <td>{{article.articleVariant.id}}</td>
        <td>{{article.articleVariant.orderNumber}}</td>
        <td>{{article.articleVariant.articleName}} {{ article.articleVariant.name }}</td>
        <td>{{ article.nonPackableState | productionUnit:false }}</td>
        <td>{{ article.minStock !== null ? (article.minStock | productionUnit:false) : '' }}</td>
        <td>
          @if (article.supplier?.name) {
            <a [routerLink]="['/suppliers']" [queryParams]="{search: article.supplier.name}">{{article.supplier.name}}</a>
            @if (article.supplier.contactPerson || article.supplier.phoneNumber || article.supplier.email || article.supplier.comment || article.supplier?.address) {
              <i nz-icon nzType="info-circle" nzTheme="outline"
                nz-tooltip
                [nzTooltipTitle]="article.supplier | supplierTooltip"
              style="margin-left: 4px; cursor: help;"></i>
            }
          }
        </td>
        <td class="next-deliver">{{article.orderDate ? (article.orderDate | dateFormat) : '–'}}</td>
        <td>{{article.orderSupplier?.name || '–'}}</td>
        <td>
          {{ article.orderQuantitySum ? (article.orderQuantitySum | productionUnit:false) : 'Keine weitere Lieferung geplant' }}
        </td>
        <td>
          <div class="actions">
            <app-icon-button
              icon="edit"
              [ariaLabel]="'Fremdmarke bearbeiten: ' + article.articleVariant.name"
              [link]="['/bulk-containers/non-packing/', article.articleVariant.id]"
              [queryParams]="{ tab: 'deliveries' }"
            ></app-icon-button>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
</div>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
<app-add-edit-order-modal>
  #addEditOrderModal
  [orderType]="orderTypes.NonPacking"
  (refresh)="onOrderCreated()"
></app-add-edit-order-modal>
